// extracted by mini-css-extract-plugin
export default {"container":"PlanTypeSegmentedControl-module__container--IsB88","segment":"PlanTypeSegmentedControl-module__segment--zxTOc","active":"PlanTypeSegmentedControl-module__active--HAlAQ"};